import Dropdown from "../Dropdown";
import Menu from "../Menu";
import useGetCurrentQuoteRevision from "../SelectedQuoteRevisionIdContext/useGetCurrentQuoteRevision";
import useSetSelectedQuoteRevisionId from "../SelectedQuoteRevisionIdContext/useSetSelectedQuoteRevisionId";
import useToPage from "../useToPage";
import { components } from "../ApiSchema";
import useCreateQuoteRevision from "../queries/useCreateQuoteRevision";
import { quoteRevisionStatusLabel } from "../utils";
import { Tooltip } from "react-tooltip";
import { useWsRfq } from "../websocket/useRfq";
import CaretDownIcon from "../CaretDownIcon";

export default function SelectQuoteRevision() {
  const rfq = useWsRfq();
  const { toRfq } = useToPage();
  const createQuoteRevision = useCreateQuoteRevision();
  const setSelectedQuoteRevisionId = useSetSelectedQuoteRevisionId();
  const quoteRevision = useGetCurrentQuoteRevision();
  const quoteRevisions = rfq?.quote_revisions ?? [];
  const canCreateNewQuoteRevision =
    incompleteQuoteRevisionCount(quoteRevisions) === 0;

  return (
    <Dropdown
      trigger={({ expanded }: { expanded: boolean }) => (
        <div className="flex gap-2 cursor-pointer">
          <div className="text-slate-900 text-sm">
            Quote Rev {quoteRevision?.revision_number}
          </div>
          <CaretDownIcon expanded={expanded} />
        </div>
      )}
    >
      <Menu
        itemGroups={[
          [
            ...quoteRevisions.map(({ id, revision_number, status }) => ({
              label: (
                <div className={`flex gap-8`}>
                  <span
                    className={`${quoteRevision?.id === id ? "font-bold" : ""}`}
                  >
                    Revision {revision_number}
                  </span>
                  <span className="text-slate-400">
                    {quoteRevisionStatusLabel[status]}
                  </span>
                </div>
              ),
              click: () => {
                setSelectedQuoteRevisionId(id);
                toRfq(rfq?.id);
              },
            })),
            {
              label: (
                <>
                  <div
                    className={`${canCreateNewQuoteRevision ? "" : "cursor-not-allowed text-gray-400"}`}
                    onClick={(e) => {
                      if (canCreateNewQuoteRevision) {
                        createQuoteRevision();
                      } else {
                        e.stopPropagation();
                      }
                    }}
                    data-tooltip-id={tooltipId}
                  >
                    Create New
                  </div>
                  {!canCreateNewQuoteRevision && (
                    <Tooltip id={tooltipId}>
                      Can't create new quote revision because there is still
                      some quote revision in progress.
                    </Tooltip>
                  )}
                </>
              ),
            },
          ],
        ]}
      />
    </Dropdown>
  );
}

function incompleteQuoteRevisionCount(
  quoteRevisions: components["schemas"]["QuoteRevisionFullSchema"][],
) {
  return quoteRevisions.reduce(
    (count, revision) =>
      (count += isQuoteRevisionIncompolete(revision) ? 1 : 0),
    0,
  );
}

function isQuoteRevisionIncompolete(
  quoteRevision: components["schemas"]["QuoteRevisionFullSchema"],
) {
  return ["new", "estimated", "quote_created"].includes(quoteRevision.status);
}

const tooltipId = "createQuoteRevision";
